
var content = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./ub-page-grid.css");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../build-v2/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./ub-page-grid.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./ub-page-grid.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// C:/phpStudy/PHPTutorial/WWW/xbigger/fnjinew/build-v2/node_modules/style-loader!./common/ub-page-grid.css
// module id = 103
// module chunks = 2 3 4 5 6 7